// extracted by mini-css-extract-plugin
module.exports = {"maxmobilewidth":"600px","mintabletwidth":"601px","maxtabletwidth":"960px","mindesktopwidth":"961px","not_found_page":"styles-module__not_found_page___OTWVE"};